import React from 'react';
import { useI18n } from '../../hooks/useI18n';

const phaseLabelKeys = {
  sandbox: 'previewLoadingPhaseSandbox',
  iframe: 'previewLoadingPhaseIframe',
  expired: 'previewLoadingPhaseExpired'
};

export const PreviewLoadingExperience = ({
  progress,
  phase = 'sandbox',
  titleKey = 'previewLoadingTitle',
  className = ''
}) => {
  const { t } = useI18n();
  const phaseLabel = t(phaseLabelKeys[phase] || phaseLabelKeys.sandbox);
  const roundedProgress = Math.round(progress);

  return (
    <div
      className={`relative flex min-h-[560px] flex-1 items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_18%_12%,rgba(20,184,166,0.16)_0%,transparent_42%),radial-gradient(circle_at_82%_88%,rgba(249,115,22,0.14)_0%,transparent_40%),radial-gradient(circle_at_top,#fffdf6_0%,#f7f0e2_40%,#f5f5f7_100%)] p-6 dark:bg-[radial-gradient(circle_at_18%_12%,rgba(45,212,191,0.12)_0%,transparent_42%),radial-gradient(circle_at_82%_88%,rgba(251,146,60,0.1)_0%,transparent_40%),radial-gradient(circle_at_top,#11212b_0%,#0f172a_45%,#020617_100%)] ${className}`}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="preview-loading-orb preview-loading-orb-a" />
        <div className="preview-loading-orb preview-loading-orb-b" />
        <div className="preview-loading-grid" aria-hidden="true" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        <p className="text-center text-sm leading-7 text-slate-600 dark:text-slate-300">{phaseLabel}</p>

        <div className="mt-6 rounded-full border border-[#123629]/10 bg-white/85 p-1.5 shadow-sm dark:border-teal-300/15 dark:bg-slate-950/50">
          <div
            className="relative h-2.5 overflow-hidden rounded-full bg-slate-100/90 dark:bg-slate-900/80"
            role="progressbar"
            aria-valuenow={roundedProgress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={t(titleKey)}
          >
            <div className="preview-loading-progress-fill h-full rounded-full" style={{ width: `${progress}%` }} />
            <span className="preview-loading-progress-shimmer" aria-hidden="true" />
          </div>
        </div>

        <p className="mt-2 text-center text-xs font-semibold tabular-nums text-slate-500 dark:text-slate-400">
          {roundedProgress}%
        </p>
      </div>
    </div>
  );
};
